import teamImg  from '../assets/team.webp'; 


export const AboutPageImages = {
    teamImg
}